<template>
  <v-app>
    <v-app-bar v-if="$auth.isAuthenticated" app>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-tabs
              class="tabs"
              centered
              grow
              height="60px"
              v-model="activeTab"
            >
              <v-tab to="/" exact>Attendance List</v-tab>
              <v-tab to="/namelist/add" exact>Name List</v-tab>
              <v-tab to="/stats" exact>Stats</v-tab>
              <v-tab @click="logout">Log Out</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-content>
      <v-container v-if="$auth.isAuthenticated" fluid>
        <router-view/>
      </v-container>
      <v-container v-else fluid>
        <v-row>
          <v-col class="text-center" cols="12">
            <v-btn @click="login" color="primary">
              Log In to view
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <v-footer app>
    </v-footer>
  </v-app>
</template>

<script type="ts">
import Vue from 'vue'

export default Vue.extend({
  data: function () {
    return {
      activeTab: ''
    }
  },
  methods: {
    login () {
      this.$auth.loginWithRedirect({
        redirect_uri: window.location.origin
      })
    },
    logout () {
      this.$auth.logout({
        returnTo: window.location.origin
      })
    }
  }
})
</script>
